import { isEqual } from '@react-hookz/deep-equal';
import { useCustomCompareMemo } from '../useCustomCompareMemo/index.js';
export function useDeepCompareMemo(factory, deps) {
    return useCustomCompareMemo(factory, deps, isEqual);
}
